import {Component,OnInit,Input,OnChanges,SimpleChanges} from '@angular/core';
import * as Highcharts from 'highcharts';
import Exporting from "highcharts/modules/exporting";
Exporting(Highcharts);

@Component({
  selector: 'pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.css']
})
export class PieChartComponent implements OnInit,OnChanges {
  @Input() chartData: object;
  @Input() chartId;
  chartiid = "pieChart";
  pieChart = Highcharts;
  chartOptions = {};
  context;
  chart : any;
  piechartwidth;

  constructor() {}

  ngOnInit() {
    console.log(this.chartData);

    this.createPieChart();
    this.piechartwidth = this.chartData['width']
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.createPieChart();
  }
  createPieChart(): any {
   
    setTimeout(() => {
      if(this.chart)
        this.chart.destroy();
    this.chartOptions = {   
      exporting : {
        enabled: false
     }, 
      chart: {
        type : 'pie',
        marginRight: this.chartData['margin'],
        renderTo: 'container',
        backgroundColor :'#183863',
        margin: [0, 0, 0, 0],
        spacingTop: 0,
        spacingBottom: 0,
        spacingLeft: 0,
        spacingRight: 0
    },
    credits: {
        enabled: false
    },
    title: {
    align: this.chartData['titlealign'],
    x:this.chartData['titlex'],
    style: {
      color: '#FFF'
    },
    text: this.chartData['title']
  },
    plotOptions: {
        pie: {
            size:this.chartData['size'],
            dataLabels: {
                enabled: false
            },
            showInLegend : this.chartData['showlegend']
            
        }
    },
    legend : {
      itemStyle: {
        color: '#ffffff',
        fontWeight: 'bold'
       },
        layout: 'vertical',
        /* useHTML: true, */
        align : 'right',
        y: -100,
        x:10
    },
    series: this.chartData['seriesdata']   
    };
    console.log(this.chartOptions);
    this.chart = this.pieChart.chart(this.chartId, this.chartOptions);
    })
  }

}
